import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import PropTypes from 'prop-types';
import { getRules } from '../features/get-rules/ducks';
import InformationIcon from '../atoms/information-icon';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  display: inline-block;
  cursor: pointer;
  color: #626469 !important;
`;

class RulesDisplayer extends React.Component {
  static propTypes = {
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    rangeName: PropTypes.string,
    size: PropTypes.string,
    starterType: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {
      markdownText: '',
      isLoading: true,
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;

    this.updateStateIfMounted({ isLoading: true });
    getRules(this.props.rangeName).then((result) => {
      this.updateStateIfMounted({ markdownText: result.data, isLoading: false });
    }).catch((error) => {
      getRules(this.props.rangeName, true).then((result) => {
        this.updateStateIfMounted({ markdownText: result.data });
      }).finally(() => {
        this.updateStateIfMounted({ isLoading: false });
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rangeName !== this.props.rangeName) {
      this.updateStateIfMounted({ isLoading: true });
      getRules(this.props.rangeName).then((result) => {
        this.updateStateIfMounted({ markdownText: result.data, isLoading: false });
      }).catch((error) => {
        getRules(this.props.rangeName, true).then((result) => {
          this.updateStateIfMounted({ markdownText: result.data });
        }).finally(() => {
          this.updateStateIfMounted({ isLoading: false });
        });
      });
    }
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  render = () => {
    return (
      <Container>
        {!this.state.isLoading && this.state.markdownText &&
          <IconWrapper
            title={I10n.get('configuration.range_rules.tooltip')}
            onClick={e => {
              e.preventDefault();
              this.props.openModal({
                modalType: 'markdown_reader',
                modalProps: {
                  title: I10n.get('modal.rules.title'),
                  markdownText: this.state.markdownText,
                  onButtonClick: () => { this.props.closeModal(); },
                  starterType: this.props.starterType
                },
              });
            }}
          >
            <InformationIcon></InformationIcon>
          </IconWrapper>
        }
      </Container>
    );
  }
}

export default RulesDisplayer;
